export default "__VITE_ASSET__495717e1__"